import { isEqual } from 'lodash';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { QuantifyState } from '../store/types';

export function isValidQuery(query: QuantifyState['query']) {
  const { groupBy, duration } = query;

  if (!groupBy) {
    return false;
  }

  if (!duration) {
    return false;
  }

  if (query.compareTo?.type === 'whereClause') {
    const isFilterAEmpty =
      !query.whereClauseConfig?.whereClause ||
      isEqual(query.whereClauseConfig?.whereClause, EmptyWhereClause);

    const isFilterBEmpty =
      !query.compareTo.whereClause ||
      isEqual(query.compareTo.whereClause, EmptyWhereClause);

    return !isFilterAEmpty && !isFilterBEmpty;
  }

  return true;
}
